import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useProductPageContext } from "../../context/productPage.context";
import { InfoBlockAnchor } from "./components/infoBlockAnchor.component";
import { Navigation } from "./components/navigation";
import { hasDocuments } from "./helpers";
import { Description } from "./sections/description/description";
import { DocumentList } from "./sections/documentList/documentList";
import { FeatureList } from "./sections/featureList/featureList";

const ProductInfo = () => {
    const { t } = useGranite();
    const { product, maxVisibleFeatures } = useProductPageContext();

    const hasDocumentResult = hasDocuments(product);

    return (
        <>
            <InfoBlockAnchor id="specs" />
            <h2 className={cn("tw:my-2")}>
                <span>{t("productDetail.title.productInfo")}</span>
            </h2>

            <Navigation product={product} />

            <div className={cn("tw:pb-6 tw:sm:pb-0")}>
                <Description description={product.description} />
                <FeatureList
                    product={product}
                    maxVisibleFeatures={maxVisibleFeatures}
                />
                {hasDocumentResult && <DocumentList product={product} />}
            </div>
        </>
    );
};

export { ProductInfo };
